import React from "react";

const FiltersBar = ({
  viewMode,
  setViewMode,
  season,
  setSeason,
  seasonOptions,
  selectedGenre,
  setSelectedGenre,
  selectedAnnee,
  setSelectedAnnee,
  anneesOptions,
  selectedGroup,
  setSelectedGroup,
  groupOptions,
  selectedAgeCategory,
  setSelectedAgeCategory,
  ageCategoryOptions,
  sortBy,
  setSortBy,
}) => {
  return (
    <div className="space-y-3 mb-4">
      <div className="flex flex-wrap items-center justify-center gap-2">
        <button
          type="button"
          onClick={() => setViewMode("distribution")}
          className={`px-4 py-2 rounded-xl border text-sm font-medium transition ${
            viewMode === "distribution"
              ? "bg-blue-600 text-white border-blue-600 shadow"
              : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-100 dark:border-gray-700 dark:hover:bg-gray-700"
          }`}
        >
          Vue répartitions
        </button>

        <button
          type="button"
          onClick={() => setViewMode("members")}
          className={`px-4 py-2 rounded-xl border text-sm font-medium transition ${
            viewMode === "members"
              ? "bg-violet-600 text-white border-violet-600 shadow"
              : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-100 dark:border-gray-700 dark:hover:bg-gray-700"
          }`}
        >
          Vue adhérents
        </button>
      </div>

      <div className="flex justify-center gap-2 flex-wrap">
        <select
          value={season}
          onChange={(e) => setSeason(e.target.value)}
          className="p-2.5 border rounded-xl appearance-none bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-white"
        >
          {seasonOptions.map((s) => (
            <option
              key={s}
              value={s}
              className="bg-gray-200 dark:bg-gray-700 dark:text-white"
            >
              {s}
            </option>
          ))}
        </select>

        <select
          value={selectedGenre}
          onChange={(e) => setSelectedGenre(e.target.value)}
          className="p-2.5 border rounded-xl appearance-none bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-white"
        >
          <option
            value="Tous"
            className="bg-gray-200 dark:bg-gray-700 dark:text-white"
          >
            Tous les genres
          </option>
          <option
            value="Masculin"
            className="bg-gray-200 dark:bg-gray-700 dark:text-white"
          >
            Masculin
          </option>
          <option
            value="Féminin"
            className="bg-gray-200 dark:bg-gray-700 dark:text-white"
          >
            Féminin
          </option>
        </select>

        <select
          value={selectedAnnee}
          onChange={(e) => setSelectedAnnee(e.target.value)}
          className="p-2.5 border rounded-xl appearance-none bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-white"
        >
          <option
            value="Tous"
            className="bg-gray-200 dark:bg-gray-700 dark:text-white"
          >
            Toutes les années
          </option>
          {anneesOptions.map((y) => (
            <option
              key={y}
              value={y}
              className="bg-gray-200 dark:bg-gray-700 dark:text-white"
            >
              {y}
            </option>
          ))}
        </select>

        <select
          value={selectedGroup}
          onChange={(e) => setSelectedGroup(e.target.value)}
          className="p-2.5 border rounded-xl appearance-none bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-white min-w-[12rem]"
          title="Filtrer par groupe d'entraînement"
        >
          <option
            value=""
            className="bg-gray-200 dark:bg-gray-700 dark:text-white"
          >
            Tous les groupes
          </option>
          {groupOptions.map((g) => (
            <option
              key={g}
              value={g}
              className="bg-gray-200 dark:bg-gray-700 dark:text-white"
            >
              {g}
            </option>
          ))}
        </select>

        <select
          value={selectedAgeCategory}
          onChange={(e) => setSelectedAgeCategory(e.target.value)}
          className="p-2.5 border rounded-xl appearance-none bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-white min-w-[14rem]"
          title="Filtrer par catégorie d'âge"
        >
          <option
            value="Tous"
            className="bg-gray-200 dark:bg-gray-700 dark:text-white"
          >
            Toutes les catégories d&apos;âge
          </option>
          {ageCategoryOptions.map((item) => (
            <option
              key={item.value}
              value={item.value}
              className="bg-gray-200 dark:bg-gray-700 dark:text-white"
            >
              {item.label}
            </option>
          ))}
        </select>

        {viewMode === "members" && (
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="p-2.5 border rounded-xl appearance-none bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-white min-w-[12rem]"
            title="Tri de la liste"
          >
            <option
              value="name-asc"
              className="bg-gray-200 dark:bg-gray-700 dark:text-white"
            >
              Tri nom A → Z
            </option>
            <option
              value="name-desc"
              className="bg-gray-200 dark:bg-gray-700 dark:text-white"
            >
              Tri nom Z → A
            </option>
            <option
              value="weight-asc"
              className="bg-gray-200 dark:bg-gray-700 dark:text-white"
            >
              Tri poids croissant
            </option>
            <option
              value="weight-desc"
              className="bg-gray-200 dark:bg-gray-700 dark:text-white"
            >
              Tri poids décroissant
            </option>
          </select>
        )}
      </div>
    </div>
  );
};

export default FiltersBar;